export const json = {
  completedHtml: 'Благодарим за сотрудничество!',
  pages: [
    {
      elements: [
        {
          choices: [
            'конкурс существенно влияет на повышение престижа профессии учителя',
            'конкурс влияет на повышение престижа учителей-участников конкурса',
            'конкурс не влияет на повышение престижа профессии учителя'
          ],
          name: '1_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» влияет на повышение престижа профессии учителя?',
          type: 'checkbox',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '2_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как способ популяризации профессии учителя?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '3_element',
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как механизм выявления и распространения лучших педагогических практик?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '4_element',
          title:
            'Считаете ли Вы количество конкурсных испытаний для выявления победителя Конкурса-2020 достаточным?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '5_element',
          title: 'Считаете ли Вы необходимым и целесообразным оценивание конкурсных испытаний финала Конкурса ученическим и родительским жюри?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: '6_1',
              text: 'да',
            },
            {
              value: '6_2',
              text: 'не в полной мере',
            },
            {
              value: '6_3',
              text: 'нет',
            },
          ],
          name: '6_element',
          title:
            'Считаете ли Вы подготовку членов жюри к оцениванию конкурсных испытаний на установочном семинаре достаточной?',
          type: 'radiogroup',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_1',
              title: 'интересны родителям и ученикам:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_2',
              title: 'понятны родителям и ученикам:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_3',
              title: 'демонстрируют индивидуальность учителя:',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '7_4',
              title: 'Иное',
              type: 'text',
            },
          ],
          name: '7_element',
          showNumber: true,
          title:
            'Считаете ли Вы, что выступления учителей в конкурсных испытаниях:',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '8_1',
              title: 'понятны:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '8_2',
              title: 'удобны для оценивания:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '8_3',
              title: 'позволяют оценить профессиональные качества учителя:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '8_4',
              title: 'позволяют оценить личностные качества учителя:',
              type: 'radiogroup',
            },
          ],
          name: '8_element',
          showNumber: true,
          title:
            'Оцените, насколько критерии и показатели для оценивания конкурсных испытаний в оценочных листах:',
          type: 'panel',
        },
        {
          name: '9_element',
          title:
            'Что вызвало у Вас затруднения при оценке конкурсных испытаний второго и третьего туров финала Конкурса?:',
          type: 'comment',
        },
        {
          choices: [
            {
              value: '10_1',
              text: 'комфортные',
            },
            {
              value: '10_2',
              text: 'недостаточно комфортные',
            },
            {
              value: '10_3',
              text: 'некомфортные',
            },
          ],
          name: '10_element',
          showNumber: true,
          title:
            'Оцените условия Вашей работы в качестве члена жюри:',
          type: 'radiogroup',
        },
        {
          name: '11_element',
          title:
            'Поделитесь своими впечатлениями от участия в работе жюри финала Конкурса:',
          type: 'comment',
        },
        {
          name: '12_element',
          title:
            'Ваши предложения по совершенствованию финала Конкурса:',
          type: 'comment',
        },
      ],
      name: 'page1',
      showNumber: false,
      showQuestionNumbers: 'true',
      title:
        'Уважаемый эксперт! Просим Вас выразить свое мнение об организации и проведении Всероссийского конкурса «Учитель года России» 2020 года. Ваши ответы помогут при подготовке и проведении Всероссийского конкурса «Учитель года России» в 2021 году. ',
    },
  ],
  showCompletedPage: true,
  title: 'АНКЕТА ЭКСПЕРТА РОДИТЕЛЬСКОГО и УЧЕНИЧЕСКОГО ЖЮРИ финала Всероссийского конкурса «Учитель года России» 2020 года'
};
